import React from 'react';
import styled from 'styled-components';

import Icon from 'src/components/Icon';
import { LEVEL_TRAVEL_OPERATOR_ID } from 'src/constants/flights';
import PackageInfoItem from './PackageInfoItem';
import type { IPackageMealInfo } from '../types';
import { PACKAGE_MEAL_INFO_TEST_ID } from '../constants';

const MEAL_ICON = <Icon type="food" />;
const PackageMealInfo = ({
  meal,
  mealCode,
  mealOriginal = null,
  operatorId,
  icon,
  isMobile,
}: IPackageMealInfo): JSX.Element => {
  const isLTOperator = operatorId === LEVEL_TRAVEL_OPERATOR_ID;
  return (
    <StyledPackageInfoItem
      icon={icon || MEAL_ICON}
      text={`${meal} (${mealCode})`}
      isMobile={isMobile}
    >
      {mealOriginal && meal !== mealOriginal && (
        <StyledFoodType
          data-testid={PACKAGE_MEAL_INFO_TEST_ID}
          isMobile={isMobile}
        >
          {!isLTOperator && ` · ${mealOriginal}`}
        </StyledFoodType>
      )}
    </StyledPackageInfoItem>
  );
};

const StyledPackageInfoItem = styled(PackageInfoItem)`
  max-width: 300px;
  display: flex;
  align-items: center;
`;

const StyledFoodType = styled.span<{ isMobile: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? 13 : 14)}px;
  & + * {
    margin-left: 13px;
  }
  margin-left: 0;
  color: #919499;
`;

export default PackageMealInfo;
